import React, { useContext, useEffect, useRef, useState } from 'react';
import { SocialContext } from '../contexts/socialContext';
import { ListAvatars } from './Lists/ListAvatars';
import { ListAvatarsLayout } from './Lists/ListAvatarsLayout';

export function FollowList(props) {
  const context = { ...useContext(SocialContext) };
  const sectionRef = useRef(null);

  const { 
    token = '', 
    count = 0, 
    list = 'followings', 
    array,
    style,
    children,
    mode = 'hd'
  } = { ...props };

  const scrollToTop = () => {
    sectionRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>

      {Boolean(children) && <div
        className={`x_choose--v ${list ? `x_choose--${list}` : ''}`}
        style={{ width: '100%' }}
      >
        {children}
      </div>}
      
      {/* <div className='x_choose x_choose--v x_choose--followers_pop'> */}

     <ListAvatarsLayout 
        icon=''
        // quantity={array?.length}
        listId={list}
        className='followers_pop'
        style={{ ...style }}
        sectionRef={sectionRef}
      >
        <ListAvatars
          listId='followers'
          quantity={array ? array.length : null}
          array={array}
          customGridClass='x_choose x_choose--v x_choose--followers_pop'
          // fullList={true}
          paginate={12}
          mode={mode}
          scrollToTop={scrollToTop}
        />
      </ListAvatarsLayout> 

{/* </div> */}

    </>
  )
}